<template>
  <button
    class="btn"
    :disabled="disabled || processing"
    @click="handleClick"
  >
    <template v-if="!icon">
      <FontAwesomeIcon
        v-if="processing"
        :icon="faSpinnerThird"
        spin
        class="text-lg"
      />

      <slot />
    </template>

    <i
      v-if="icon"
      class="fa-regular"
      :class="icon"
    />
  </button>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  processing: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['click']);

const handleClick = () => {
  if (!props.disabled) {
    emit('click');
  }
};
</script>

